(function () {
  'use strict';
  const disposers = new WeakMap();
  function initialise(root) {
  if (!root || !window.HewnCurated || disposers.has(root)) return;
  let disposed = false, observer;
  const listeners = [];
  const abortController = typeof window.AbortController === 'function' ? new window.AbortController() : null;
  function on(target, type, handler, options) { target.addEventListener(type, handler, options); listeners.push(() => target.removeEventListener(type, handler, options)); }
  disposers.set(root, () => { disposed = true; abortController?.abort(); clearTimeout(searchTimer); if (appendFrame !== null) window.cancelAnimationFrame(appendFrame); observer?.disconnect(); listeners.forEach(remove => remove()); disposers.delete(root); });
  const C = window.HewnCurated, sale = window.HewnEarthSale, saleEnabled = sale?.enabled === true, grid = root.querySelector('[data-curated-grid]'), controls = root.querySelector('[data-curated-controls]');
  const search = root.querySelector('[data-curated-search]'), status = root.querySelector('[data-curated-count]'), retry = root.querySelector('[data-curated-retry]');
  const sentinel = root.querySelector('[data-curated-sentinel]'), empty = root.querySelector('[data-curated-empty]');
  let state = C.readState(location.href), catalog = null, filtered = [], currency = root.dataset.currency, limit = 24, loading = false, appendFrame = null;
  if (!new URL(location.href).searchParams.has('columns')) { try { if (localStorage.getItem('listingColumns') === '3') state.columns = 3; } catch (_) {} }
  function element(tag, className, text) { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; }
  function card(item, index) {
    const article = element('article', 'curated-card'), link = element('a', 'curated-card__link'), media = element('div', 'curated-card__media');
    link.href = item.url;
    const img = element('img'); img.src = item.image; img.alt = item.imageAlt || item.title; img.width = item.width; img.height = item.height; img.loading = index < 4 ? 'eager' : 'lazy'; img.decoding = 'async';
    img.sizes = '(max-width: 760px) 50vw, ' + (state.columns === 3 ? '33vw' : '25vw');
    try { img.srcset = [360, 540, 720, 1000].map(width => { const url = new URL(item.image, location.origin); url.searchParams.set('width', width); return `${url.href} ${width}w`; }).join(', '); } catch (_) {}
    media.append(img, element('span', 'curated-card__badge', 'Set of 2'));
    if (saleEnabled) media.insertAdjacentHTML('beforeend', sale.badgeHTML());
    if (saleEnabled && (!Array.isArray(item.componentPrices) || item.componentPrices.length !== 2)) throw new Error('The current set prices could not load.');
    const bundleEligible = item.bundleEligible !== false;
    const quote = C.quote((item.componentPrices || [item.price]).map(price => ({price})), {saleEnabled, bundleEligible, currency});
    const price = element('p', 'curated-card__price', 'From ');
    const current = element('span', '', C.money(quote.total, currency));
    current.setAttribute('aria-label', `Set price ${current.textContent}`); price.append(current, ' ');
    if (quote.original > quote.total) {
      const original = element('s', '', C.money(quote.original, currency));
      original.setAttribute('aria-label', `Regular price ${original.textContent}`); price.append(original);
    }
    const saving = saleEnabled ? `${sale.rate}% off · ${sale.multiRate}% off as a set of 2+` : (bundleEligible ? 'Save 5% as a set' : '');
    link.append(media, element('h2', '', item.title), price, element('p', 'curated-card__saving', saving)); article.append(link); return article;
  }
  function buildFacets() {
    C.FACETS.forEach(key => {
      const menu = root.querySelector(`[data-facet-options="${key}"]`); menu.replaceChildren();
      C.facetValues(catalog, key, {}).forEach(({value}) => {
        const label = element('label'), input = element('input'), text = element('span', '', value), count = element('small');
        input.type = 'checkbox'; input.name = key; input.value = value; count.dataset.facetCount = ''; label.append(input, text, count); menu.append(label);
      });
      if (!menu.children.length) menu.append(element('p', '', 'No options available'));
    });
  }
  function updateResultsStatus() {
    const noun = root.hasAttribute('data-curated-embedded') ? (filtered.length === 1 ? 'set' : 'sets') : (filtered.length === 1 ? 'curated set' : 'curated sets');
    status.textContent = `${filtered.length} ${noun}${filtered.length > limit ? ` · Showing ${limit}` : ''}`;
    empty.hidden = filtered.length !== 0;
    sentinel.hidden = filtered.length === 0;
    sentinel.textContent = filtered.length > limit ? 'More sets appear as you scroll' : `All ${filtered.length} ${filtered.length === 1 ? 'curated set' : 'curated sets'} shown.`;
  }
  function scheduleAppend() {
    if (disposed || appendFrame !== null || loading || filtered.length <= limit) return;
    appendFrame = window.requestAnimationFrame(() => {
      appendFrame = null;
      if (disposed || loading || filtered.length <= limit || sentinel.hidden) return;
      if (sentinel.getBoundingClientRect().top > window.innerHeight + 600) return;
      const start = limit;
      limit = Math.min(limit + 24, filtered.length);
      grid.append(...filtered.slice(start, limit).map((item, index) => card(item, start + index)));
      updateResultsStatus();
      // Recheck after layout: a short grid may still leave the sentinel in view.
      scheduleAppend();
    });
  }
  function render(updateUrl, replace, preserveCards) {
    if (disposed || catalog === null) return;
    search.value = state.q;
    root.style.setProperty('--curated-columns', state.columns);
    root.querySelector('[data-curated-zoom]').value = String(state.columns);
    C.FACETS.forEach(key => {
      const counts = new Map(C.facetValues(catalog, key, state).map(choice => [choice.value, choice.count]));
      const facet = root.querySelector(`[data-facet="${key}"]`); facet.classList.toggle('is-selected', state[key].length > 0);
      facet.querySelectorAll('input').forEach(input => { input.checked = state[key].includes(input.value); const count = counts.get(input.value) || 0; input.disabled = count === 0 && !input.checked; input.parentElement.querySelector('small').textContent = count; });
    });
    filtered = catalog.filter(item => C.matches(item, state));
    if (preserveCards) grid.querySelectorAll('img').forEach(img => img.sizes = '(max-width: 760px) 50vw, ' + (state.columns === 3 ? '33vw' : '25vw'));
    else grid.replaceChildren(...filtered.slice(0, limit).map(card));
    updateResultsStatus();
    const active = Boolean(state.q || C.FACETS.some(key => state[key].length));
    root.querySelectorAll('.curated-filters [data-curated-clear]').forEach(button => button.hidden = !active);
    if (updateUrl) history[replace ? 'replaceState' : 'pushState']({}, '', C.writeState(location.href, state));
    scheduleAppend();
  }
  async function load() {
    if (disposed || loading) return;
    loading = true; controls.disabled = true; retry.hidden = true; sentinel.hidden = true; grid.setAttribute('aria-busy', 'true');
    status.textContent = 'Loading all curated sets…';
    try {
      const result = await C.loadCatalog(root.dataset.feedUrl, (url, options) => window.fetch(url, {...options, ...(abortController ? {signal: abortController.signal} : {})}), Number(root.dataset.expectedCount), count => { if (!disposed) status.textContent = `Loading all curated sets… ${count} loaded`; });
      if (disposed) return;
      catalog = result.items; currency = result.currency; buildFacets(); controls.disabled = false; render(false);
    } catch (error) { if (disposed) return; status.textContent = 'We couldn’t load all the sets. The selection below is still available to explore.'; retry.hidden = false; }
    finally { loading = false; grid.setAttribute('aria-busy', 'false'); scheduleAppend(); }
  }
  on(root.querySelector('form'), 'submit', event => event.preventDefault());
  on(root, 'change', event => {
    const input = event.target;
    if (!C.FACETS.includes(input.name)) return;
    state[input.name] = [...root.querySelectorAll(`input[name="${input.name}"]:checked`)].map(node => node.value); limit = 24; render(true);
  });
  let searchTimer;
  on(search, 'input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => { state.q = search.value; limit = 24; render(true, true); }, 160); });
  root.querySelectorAll('[data-curated-clear]').forEach(button => on(button, 'click', () => { clearTimeout(searchTimer); state.q = ''; C.FACETS.forEach(key => state[key] = []); limit = 24; render(true); }));
  on(root.querySelector('[data-curated-zoom]'), 'change', event => { state.columns = Number(event.target.value); try { localStorage.setItem('listingColumns', String(state.columns)); } catch (_) {} render(true, false, true); });
  on(retry, 'click', load);
  if (window.IntersectionObserver) {
    observer = new window.IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) scheduleAppend(); }, {rootMargin: '0px 0px 600px 0px'});
    observer.observe(sentinel);
  }
  // Also covers older browsers and fast jumps that pass the observer's margin.
  on(window, 'scroll', scheduleAppend, {passive: true});
  on(window, 'popstate', () => { state = C.readState(location.href); limit = 24; render(false); });
  function positionFacetMenu(detail) {
    const menu = detail.querySelector('.curated-facet__menu');
    const clientWidth = document.documentElement.clientWidth;
    const viewportWidth = clientWidth > 0 ? Math.min(innerWidth, clientWidth) : innerWidth;
    menu.style.left = '0px'; menu.style.right = 'auto'; menu.style.maxWidth = `${Math.max(0, viewportWidth - 32)}px`;
    const rect = menu.getBoundingClientRect();
    const offset = Math.max(16 - rect.left, Math.min(0, viewportWidth - 16 - rect.right));
    menu.style.left = `${offset}px`;
  }
  root.querySelectorAll('.curated-facet').forEach(detail => on(detail, 'toggle', () => {
    if (!detail.open) return;
    root.querySelectorAll('.curated-facet').forEach(other => { if (other !== detail) other.open = false; });
    positionFacetMenu(detail);
  }));
  on(window, 'resize', () => { root.querySelectorAll('.curated-facet[open]').forEach(positionFacetMenu); scheduleAppend(); });
  on(document, 'click', event => { if (!event.target.closest('.curated-facet')) root.querySelectorAll('.curated-facet[open]').forEach(detail => detail.open = false); });
  on(root, 'keydown', event => { if (event.key === 'Escape') { const detail = event.target.closest('.curated-facet'); if (detail) { detail.open = false; detail.querySelector('summary').focus(); } } });
  load();
  }
  window.HewnCuratedListings = {init: initialise, destroy: root => disposers.get(root)?.()};
  document.querySelectorAll('[data-curated-listing]').forEach(initialise);
})();
